const USER_ACTIONS = {
  USER_LOADED: 'USER_LOADED',
  USER_STATS_LOADED: 'USER_STATS_LOADED',
  CLAIMS_LOADED: 'CLAIMS_LOADED',
  FIREBASE_USER_LOADED: 'FIREBASE_USER_LOADED',
  USER_LOGOUT: 'USER_LOGOUT',
  INVALID_USER: 'INVALID_USER',
  SWITCH_ORGANISATION: 'SWITCH_ORGANISATION',
  USER_MFA_RESOLVER: 'USER_MFA_RESOLVER'
};

const userSwithOrganisationAction = ({ organisationId }) => {
  return {
    type: USER_ACTIONS.SWITCH_ORGANISATION,
    payload: { organisationId }
  };
};

const userLoadedAction = user => {
  return {
    type: USER_ACTIONS.USER_LOADED,
    payload: user
  };
};

const userLogoutAction = () => {
  return { type: USER_ACTIONS.USER_LOGOUT };
};

const userStatsLoadedAction = userStats => {
  return {
    type: USER_ACTIONS.USER_STATS_LOADED,
    payload: { userStats }
  };
};

const userMfaResolver = resolver => {
  return {
    type: USER_ACTIONS.USER_MFA_RESOLVER,
    payload: resolver
  };
};

export {
  userLoadedAction,
  userStatsLoadedAction,
  userLogoutAction,
  userSwithOrganisationAction,
  userMfaResolver
};

export default USER_ACTIONS;
